import { Grid } from "@mui/material";
import Hexagon from "./visual/Hexagon";
import { InteractableSave } from "../model/character";

export interface HexListProps {
    items: InteractableSave[];
}

export const HexList = (props: HexListProps) => {
    return <Grid container spacing={1}>
        {props.items.map(item => {
            return <Grid item xs={4} sm={3}>
                <Hexagon key={item.id} name={item.name} onClick={() => item.onClick(item.id)} />
            </Grid>
        })}
    </Grid>
}